// extracted by mini-css-extract-plugin
export default {"buttons":"_45qYsrIVXw+Wy9yFITRjTQ==","recovery_code_button":"efWmAw1QJUx2Vf-totJg7w==","resend_button":"_69v1yUblUrWSNKrAH9121w==","verification_holder":"ZYlvhBzW0sB9Vz0GFDaMiA=="};